import styled from "styled-components";
import { PrimaryHomepageHeader } from "@similarweb/ui-components";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";
import { HomepageBodyText } from "@similarweb/ui-components";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { setFont } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components";

export const PageContainer = styled.div`
    display: flex;
    flex-direction: column;
    > * {
        width: 100%;
        box-sizing: border-box;
    }
`;

export const HeaderContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 638px;
    padding: 40px 0;
    margin: 0 40px;
    box-sizing: border-box;
`;

export const TilesGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
`;

export const AutocompleteWrapper = styled.div`
    margin-top: 12px;
    transition: all 0.05s ease-out;
    width: 640px;
`;

export const PrimaryHomepageHeaderStyled = styled(PrimaryHomepageHeader)`
    position: sticky;
    display: flex;
    flex-direction: row;
    justify-content: center;
    top: 0;
    padding: 0;
    align-items: center;
    flex-wrap: wrap;
    z-index: 80;
`;

export const Text = styled.div.attrs((props) => ({
    color: props.color,
}))`
    ${(props) => mixins.setFont({ $color: props.color })};
`;

export const HeaderTitle = styled(Text).attrs(() => ({
    color: colorsPalettes.carbon[500],
}))`
    font-size: 34px;
    font-weight: 500;
    line-height: 40px;
    margin-bottom: 8px;
    font-family: "DM Sans";
`;
export const HeaderSubtitle = styled(Text).attrs(() => ({
    color: colorsPalettes.carbon[400],
}))`
    font-size: 14px;
`;

export const HomepageBodyTextStyled = styled(HomepageBodyText)`
    width: 100%;
    display: flex;
    justify-content: center;
    span {
        font-size: 24px;
        display: block;
        margin: 48px 40px 24px 40px;
        width: 638px;
    }
`;

export const TilesContainer = styled.div.attrs<{ tilesPerRow: number }>((props) => ({
    tilesPerRow: props.tilesPerRow ?? 4,
}))<{ tilesPerRow: number }>`
    display: grid;
    grid-template-columns: repeat(${(props) => props.tilesPerRow}, 1fr);
    gap: 24px;
    justify-items: center;
    width: 638px;
    margin: 0 40px;
`;

const RedirectTabsContainer = styled.span`
    > div {
        display: inline-block;
    }
`;

const RedirectEmptyState = styled.div<{ width?: number }>`
    width: ${({ width }) => (width ? `${width}px` : "auto")};
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 51px;
    img {
        margin-bottom: 66px;
    }
`;
const RedirectEmptyStateText = styled.div`
    text-align: center;
    ${setFont({ $size: 16, $color: colorsPalettes.carbon["400"] })};
`;

export const AcquisitionCustomDropdownContainer = styled.div`
    height: 40px;
`;
const RedirectStyledLoader = styled(PixelPlaceholderLoader)`
    margin-bottom: 12px;
`;

export const BoxLinksStyled = styled(Box)`
    position: absolute;
    padding: 18px 16px 8px;
`;
export const RowLink = styled.div`
    height: 52px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    border: 1px solid ${colorsPalettes.carbon[25]};
    box-shadow: 0px 3px 6px ${rgba(colorsPalettes.carbon[500], 0.08)};
    border-radius: 4px;
    margin-bottom: 8px;
    padding: 16px;
    cursor: pointer;
    &:hover {
        background-color: ${colorsPalettes.carbon[25]};
    }
`;

export const LinkChannelName = styled.div`
    ${mixins.setFontVariant("tab", colorsPalettes.carbon["500"])};
    line-height: 20px;
`;
export const LinkTitle = styled.div`
    ${mixins.setFontVariant("tooltip", colorsPalettes.carbon["300"])};
`;
export const LinkNumber = styled.div`
    ${mixins.setFontVariant("button", colorsPalettes.carbon["300"])};
`;
export const LinkText = styled.div`
    ${mixins.setFontVariant("input2", colorsPalettes.carbon["300"])};
`;
export const LinkProgressBarContainer = styled.div`
    width: 115px;
    margin-left: 8px;
`;
export const LinkPixelPlaceholderLoaderStyled = styled(PixelPlaceholderLoader)`
    margin-right: 8px;
`;
export const LinkHeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .SWReactIcons {
        svg {
            width: 16px;
            height: 16px;
            color: ${colorsPalettes.carbon["200"]};
            padding-right: 4px;
        }
    }
    .AcquisitionHomePageLinksSiteChip {
        border-radius: 4px;
    }
`;
export const LinkRowContainer = styled.div`
    display: flex;
    align-items: center;
`;
